module.exports = __webpack_public_path__ + "static/img/suchunyuan.1468408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/suchunyuan.png
// module id = 2UPl
// module chunks = 0